import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  C4_P4_S1_Title: {
    id: `case04.page04.slide01.title`,
  },
  C4_P4_S1_A1_Title: {
    id: `case04.page04.slide01.accordion01.title`,
  },
  C4_P4_S1_A1_Description: {
    id: `case04.page04.slide01.accordion01.description`,
  },
  C4_P4_S1_A2_Title: {
    id: `case04.page04.slide01.accordion02.title`,
  },
  C4_P4_S1_A2_Description: {
    id: `case04.page04.slide01.accordion02.description`,
  },
  C4_P4_S1_A3_Title: {
    id: `case04.page04.slide01.accordion03.title`,
  },
  C4_P4_S1_A3_Description: {
    id: `case04.page04.slide01.accordion03.description`,
  },
  C4_P4_S1_A4_Title: {
    id: `case04.page04.slide01.accordion04.title`,
  },
  C4_P4_S1_A4_Description: {
    id: `case04.page04.slide01.accordion04.description`,
  },
  C4_P4_S1_A5_Title: {
    id: `case04.page04.slide01.accordion05.title`,
  },
  C4_P4_S1_A5_Description: {
    id: `case04.page04.slide01.accordion05.description`,
  },
  C4_P4_S1_A6_Title: {
    id: `case04.page04.slide01.accordion06.title`,
  },
  C4_P4_S1_A6_Description: {
    id: `case04.page04.slide01.accordion06.description`,
  },
  C4_P4_S1_A7_Title: {
    id: `case04.page04.slide01.accordion07.title`,
  },
  C4_P4_S1_A7_Description: {
    id: `case04.page04.slide01.accordion07.description`,
  },
  C4_P4_S1_A8_Title: {
    id: `case04.page04.slide01.accordion08.title`,
  },
  C4_P4_S1_A8_Description: {
    id: `case04.page04.slide01.accordion08.description`,
  },
  C4_P4_S1_A9_Title: {
    id: `case04.page04.slide01.accordion09.title`,
  },
  C4_P4_S1_A9_Description: {
    id: `case04.page04.slide01.accordion09.description`,
  },
  C4_P4_S1_A9_BioLabel: {
    id: `case04.page04.slide01.accordion09.bioLabel`,
  },
  C4_P4_S1_A9_BioTitle: {
    id: `case04.page04.slide01.accordion09.bioTitle`,
  },
  C4_P4_S1_A9_BioText: {
    id: `case04.page04.slide01.accordion09.bioText`,
  },
  C4_P4_S1_A9_BioLinkLabel: {
    id: `case04.page04.slide01.accordion09.bioLinkLabel`,
  },
});
